import { render, staticRenderFns } from "./StockOpnameReport.vue?vue&type=template&id=18be3723&"
import script from "./StockOpnameReport.vue?vue&type=script&lang=js&"
export * from "./StockOpnameReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports